// Checkbox > ICheckbox
export const checkboxDefaultProps = Object.freeze({
	checked: false
})

export type CheckboxProps = {
	handleRootClick(value?: string | string[]): void
} & React.InputHTMLAttributes<HTMLInputElement>
